import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { logout as logoutIcon } from './imagepath';
import { ACTIVE_SUBMENU_KEYWORDS, MENU_ITEMS } from '../config/tenantPermissions';
import usePermissions from '../hooks/usePermissions';
import { useAuth } from '../utils/AuthContext';

const Sidebar = (props) => {
  const [sidebar, setSidebar] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1070);
  const { permissions } = usePermissions();
  const { logout } = useAuth();

  const visibleMenuItems = useMemo(() => {
    const hasAccess = (module) => permissions.includes(module);

    return MENU_ITEMS.map((item) => {
      const children = item.children.filter((child) => {
        const childModule = child.module || item.module;
        return hasAccess(childModule);
      });

      if (children.length === 0) return null;
      if (!hasAccess(item.module) && !children.some((c) => hasAccess(c.module || item.module))) {
        return null;
      }

      return { ...item, children };
    }).filter(Boolean);
  }, [permissions]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1070);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleClick = (e, item, item1, label) => {
    const div = document.querySelector(`#${item}`);
    const ulDiv = document.querySelector(`.${item1}`);

    if (!div || !ulDiv) return;

    if (sidebar === label) {
      ulDiv.style.display = 'none';
      div.classList.remove('subdrop');
      setSidebar('');
    } else {
      ulDiv.style.display = 'block';
      div.classList.add('subdrop');
      setSidebar(label);
    }
  };

  useEffect(() => {
    if (props?.activeClassName) {
      const active = props.activeClassName.toLowerCase();
      const mappingItem = ACTIVE_SUBMENU_KEYWORDS.find(
        (item) => active.indexOf(item.keyword) !== -1
      );
      if (mappingItem) {
        setSidebar(mappingItem.submenu);
        const div = document.getElementById(mappingItem.menuId);
        const ulDiv = document.querySelector(`.${mappingItem.submenuClass}`);
        if (div && ulDiv) {
          ulDiv.style.display = 'block';
          div.classList.add('subdrop');
        }
      }
    }
  }, [props.activeClassName]);

  const expandMenu = () => {
    document.body.classList.remove('expand-menu');
  };

  const expandMenuOpen = () => {
    document.body.classList.add('expand-menu');
  };

  const toggleSidebar = () => {
    if (isMobile) {
      document.body?.classList.toggle('slide-nav');
    } else {
      document.body?.classList.toggle('mini-sidebar');
    }
  };

  const renderIcon = (item) => {
    if (item.iconType === 'fa') {
      return <i className={`fa ${item.iconClass || 'fa-flag'}`} />;
    }
    return (
      <span className="menu-side">
        <img src={item.icon} alt="" className={item.iconClass || ''} />
      </span>
    );
  };

  return (
    <>
      <div className="sidebar" id="sidebar">
        <div className="sidebar-scroll" style={{ maxHeight: '95vh', overflowY: 'auto' }}>
          <div className="sidebar-inner slimscroll">
            <div
              id="sidebar-menu"
              className="sidebar-menu"
              onMouseLeave={expandMenu}
              onMouseOver={expandMenuOpen}
            >
              <ul>
                <li className="menu-title">Menu</li>
                {visibleMenuItems.map((item) => (
                  <li key={item.id} className="submenu">
                    <Link
                      to="#"
                      id={item.id}
                      onClick={(e) => handleClick(e, item.id, item.submenuClass, item.label)}
                    >
                      {renderIcon(item)}{' '}
                      <span>{item.label}</span> <span className="menu-arrow" />
                    </Link>
                    <ul
                      style={{ display: sidebar === item.label ? 'block' : 'none' }}
                      className={item.submenuClass}
                    >
                      {item.children.map((child) => (
                        <li key={child.path}>
                          <Link
                            className={props?.activeClassName === child.activeKey ? 'active' : ''}
                            to={child.path}
                          >
                            {child.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
              <div className="logout-btn">
                <Link
                  to="/login"
                  onClick={(e) => {
                    e.preventDefault();
                    logout();
                  }}
                >
                  <span className="menu-side">
                    <img src={logoutIcon} alt="" />
                  </span>{' '}
                  <span>Salir</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar-overlay" onClick={toggleSidebar}></div>
    </>
  );
};

export default Sidebar;
